import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api";
import {
  Container,
  Paper,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
  MenuItem,
  Radio,
  RadioGroup,
  FormLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Autocomplete,

} from "@mui/material";
import { Save as SaveIcon, Cancel as CancelIcon } from "@mui/icons-material";
import AdminLayout from "./AdminLayout";
import SignaturePad from "react-signature-canvas";
import { toast, ToastContainer } from "react-toastify";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function EditForm() {
  const { id } = useParams(); // Get record ID from URL
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [signatureType, setSignatureType] = useState("upload");
  const signaturePadRef = useRef(null);
  const [openTerms, setOpenTerms] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [ipAddress, setIpAddress] = useState("");

  
  const [formData, setFormData] = useState({
    EmpName: "",
    EmpID: "",
    Manager: "",
    Department: "",
    Title: "",
    phone: "",
    email: "",
    address: "",
    City: "",
    State: "",
    Country: "",
    Zip: "",
    assetId: "",
    serialNumber: "",
    Model: "",
    ModelNo: "",
    Manufacturer: "",
    accessories: "",
    Specifications: "",
    AccessoriesExtra: "",
    Receivedby: "",
    idProofPath: "",
    signaturePath: "",
    assetImages: "" || [],
    termsAccepted: false,
    date: new Date().toISOString().split("T")[0],
  });
  const [fieldOptions, setFieldOptions] = useState({
    manufacturers: [
      "Dell",
      "HP",
      "Lenovo",
      "Acer",
      "Asus",
      "Apple",
      "MSI",
      "Samsung",
      "Microsoft",
    ],
    specifications: [
      "i3, 8GB, 256GB SSD",
      "i5, 8GB, 256GB SSD",
      "i7, 8GB, 256GB SSD",
      "i3, 16GB, 512GB SSD",
      "i5, 16GB, 512GB SSD",
      "i7, 16GB, 512GB SSD",
    ],
  });

  useEffect(() => {
    axios
      .get("/assets/field-options")
      .then((res) =>
        setFieldOptions({
          manufacturers: res.data.result?.manufacturers?.length
            ? res.data.result.manufacturers
            : fieldOptions.manufacturers,
          specifications: res.data.result?.specifications?.length
            ? res.data.result.specifications
            : fieldOptions.specifications,
        })
      )
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchRecordData();

    // Get location
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLatitude(pos.coords.latitude);
        setLongitude(pos.coords.longitude);
      },
      (err) => console.error("Geolocation error:", err)
    );

    // Get IP address (external service is configurable)
    const ipLookupUrl =
      process.env.REACT_APP_IP_LOOKUP_URL || "https://api.ipify.org?format=json";
    fetch(ipLookupUrl)
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch((err) => console.error("IP fetch error:", err));

    const emailParam = new URLSearchParams(window.location.search).get("email");
    if (emailParam) setFormData((prev) => ({ ...prev, email: emailParam }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchRecordData = async () => {
    try {
      setLoading(true);
      setError("");
      const response = await axios.get(`/undertaking/record/${id}`);
      const recordData = response.data;
      const assetImages = recordData.assetImages || []
      const idProofPath = recordData.idProofPath
      // Populate form with existing data
      setFormData({
        EmpName: recordData.EmpName || "",
        EmpID: recordData.EmpID || "",
        Department: recordData.Department || "",
        Title: recordData.Title || "",
        address: recordData.address || "",
        phone: recordData.phone || "",
        email: recordData.email || "",
        Manager: recordData.Manager || "",
        City: recordData.City || "",
        State: recordData.State || "",
        Country: recordData.Country || "",
        Zip: recordData.Zip || "",
        assetId: recordData.assetId || "",
        serialNumber: recordData.serialNumber || "",
        Model: recordData.Model || "",
        ModelNo: recordData.ModelNo || "",
        Manufacturer: recordData.Manufacturer || "",
        accessories: recordData.accessories || "",
        Specifications: recordData.Specifications || "",
        AccessoriesExtra: recordData.AccessoriesExtra || "",
        Receivedby: recordData.Receivedby || "",
        idProofPath, 
        signaturePath: recordData.signaturePath,
        assetImages,
        termsAccepted: recordData.termsAccepted || false,
        date: recordData.date || new Date().toISOString().split("T")[0],
      });
      
    } catch (err) {
      console.error("Error fetching record:", err);
      setError(
        err.response?.data?.message || 
        "Error loading record data. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        [name]: name === "assetImages" ? files : files[0],
      }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("e",e)
    try {
      setSaving(true);
      setError("");
      setSuccess("");

      // Validate required fields (based on original form requirements)
      const requiredFields = [
        "EmpName", "EmpID", "address", "phone", "email", 
        "assetId", "serialNumber", "Manufacturer", "accessories", 
        "Specifications", "Receivedby"
      ];

      const missingFields = requiredFields.filter(field => !formData[field]);
      
      if (missingFields.length > 0) {
        setError(`Please fill in all required fields: ${missingFields.join(", ")}`);
        return;
      }
      
      if (!formData.termsAccepted) {
        setError("Please accept the terms and conditions to proceed.");
        return;
      }
      
      // Update the record
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "assetImages") {
          for (let file of formData.assetImages || [])
            data.append("assetImages", file);
        } else if (key === "idProofPath" || key === "signaturePath") {
          if (formData[key]) {
            data.append(key, formData[key]);
          }
        } else {
          data.append(key, formData[key]);
        }
      });

      // Handle signature drawing
      if (signatureType === "draw" && signaturePadRef.current) {
        if (!signaturePadRef.current.isEmpty()) {
          const url = signaturePadRef.current.toDataURL("image/png");
          const blob = await (await fetch(url)).blob();
          data.set(
            "signaturePath",
            new File([blob], "signature.png", { type: "image/png" })
          );
        }
      }

      data.append("timestamp", new Date().toISOString());

      await axios.put(`/undertaking/update/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // setFormData(existingRecord);
      setSuccess("Record updated successfully!");
      toast.success("Record Updated and Invite Sent Successfully!")

      // Navigate back to asset details after a short delay
      setTimeout(() => {
        navigate("/asset");
      }, 1500);

    } catch (err) {
      console.error("Error updating record:", err);
      setError(
        err.response?.data?.message || 
        "Error updating record. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate("/asset");
  };

  const renderTextField = (name, label, required = false, disabled = false) => (
    <Grid item xs={12} sm={6}>
      <TextField
        name={name}
        label={label}
        value={formData[name] || ""}
        onChange={handleChange}
        fullWidth
        required={required}
        disabled={disabled}
        variant="outlined"
      />
    </Grid>
  );

  if (loading) {
    return (
      <AdminLayout title="Edit Asset Undertaking">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout
      title="Edit Asset Undertaking"
      actions={
        <IconButton color="inherit" onClick={() => navigate(-1)} title="Go Back">
          <ArrowBackIcon />
        </IconButton>
      }
    >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom 
              style={{
                fontFamily:"Times New Roman"
              }}
            >
              Edit Asset Undertaking Form
            </Typography>
            
            {error && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {error}
              </Alert>
            )}
            
            {success && (
              <Alert severity="success" sx={{ mb: 3 }}>
                {success}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              {/* Employee Information Section */}
              <Typography variant="h6" gutterBottom sx={{ mt: 3, mb: 2 }}
                style={{
                  fontFamily:"Times New Roman",
                  fontSize:"22px"
                }}
              >
                Employee Information
              </Typography>
              <Divider sx={{ my: 2 }} />
              
              <Grid container spacing={3}>
                {renderTextField("EmpName", "Employee Name", true)}
                {renderTextField("EmpID", "Employee ID", true)}
                {renderTextField("Department", "Department")}
                {renderTextField("Title", "Title")}
                {renderTextField("address", "Address", true)}
                {renderTextField("phone", "Phone", true)}
                {renderTextField("email", "Email", true, true)} {/* Email disabled */}
                {renderTextField("Manager", "Manager")}
                {renderTextField("City", "City")}
                {renderTextField("State", "State")}
                {renderTextField("Country", "Country")}
                {renderTextField("Zip", "Zip")}
              </Grid>

              <Divider sx={{ my: 4 }} />


              {/* Asset Information Section */}
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}
                style={{
                  fontFamily:"Times New Roman"
                }}
              >
                Asset Information
              </Typography>
              
              <Grid container spacing={3}>
                {renderTextField("assetId", "Asset ID", true)}
                {renderTextField("serialNumber", "Serial Number", true)}
                {renderTextField("Model", "Model")}
                
                  <Autocomplete
                    freeSolo
                    options={fieldOptions.manufacturers}
                    value={formData.Manufacturer || ""}
                    onChange={(_, newValue) =>
                      setFormData({ ...formData, Manufacturer: newValue || "" })
                    }
                    onInputChange={(_, newInputValue, reason) => {
                      if (reason === "input" || reason === "clear") {
                        setFormData({
                          ...formData,
                          Manufacturer: newInputValue || "",
                        });
                      }
                    }}
                    sx={{ width: "28.7%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="Manufacturer"
                        label="Manufacturer"
                        placeholder="Select Manufacturer"
                        required
                        variant="outlined"
                      />
                    )}
                  />
                  <TextField
                    name="accessories"
                    label="Accessories"
                    value={formData.accessories}
                    placeholder="Select Accessories"
                    // onChange={(e) =>
                    //   handleChange({
                    //     target: {
                    //       name: "accessories",
                    //       value:
                    //         typeof formData.accessories === "string"
                    //           ? formData.accessories.split(",")
                    //           : formData.accessories,
                    //     },
                    //   })
                    // }
                    // select
                    // SelectProps={{ multiple: true }}
                    onChange={handleChange}
                    fullWidth
                    required
                    style={{ width: "28.7%" }} 
                    variant="outlined"
                  >
                    {["Bag", "Mouse", "Keyboard", "Monitor", "Headphone"].map(
                      (accessory) => (
                        <MenuItem key={accessory} value={accessory}>
                          {accessory}
                        </MenuItem>
                      ),
                    )}
                  </TextField>
                  <Autocomplete
                  
                    freeSolo // allows manual typing
                  
                    options={fieldOptions.specifications}
                  
                    value={formData.Specifications || ""}
                  
                    onChange={(event, newValue) => {
                  
                      setFormData({ ...formData, Specifications: newValue });
                  
                    }}
                  
                    onInputChange={(event, newInputValue) => {
                  
                      setFormData({ ...formData, Specifications: newInputValue });
                  
                    }}
                  
                    renderInput={(params) => (
                  <TextField
                  
                        {...params}
                  
                        name="Specifications"
                  
                        label="Specifications"
                  
                        placeholder="Select or type Specifications"
                  
                        required
                  
                        style={{ width: "300px" }}
                  
                      />
                  
                    )}
                  
                  />
                  
                {renderTextField("Receivedby", "Received By", true)}

                
              </Grid>

              <Divider sx={{ my: 4 }} />


              {/* Uploads Section */}
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Uploads
              </Typography>
              
              <Grid container spacing={3}>
                {/* ID Proof Upload */}
                <Grid item xs={12} sm={6}>
              <Box className="upload-box">
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  style={{ fontFamily: "Times New Roman" }}
                >
                  ID Proof
                </Typography>
                <label htmlFor="idProofPath" className="upload-label">
                  Choose File
                  <input
                    type="file"
                    id="idProofPath"
                    name="idProofPath"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className="upload-input"
                  />
                </label>
                    {formData.idProofPath && (
                      <p>
                        {Array.isArray(formData.idProofPath)
                          ? formData.idProofPath
                              .map((f) => (typeof f === "string" ? f.split("/").pop() : f.name))
                              .join(", ")
                          : typeof formData.idProofPath === "string"
                          ? formData.idProofPath.split("/").pop()
                          : ""}
                      </p>
                    )}
                  </Box>
                </Grid>

                {/* Asset Images Upload */}
                    <Grid item xs={12} sm={6}>
                        <Box className="upload-box">
                    <Typography
                    variant="subtitle1"
                    style={{ fontFamily: "Times New Roman" }}
                    gutterBottom
                    >
                    Asset Images
                    </Typography>
                    <label htmlFor="assetImages" className="upload-label">
                    Choose Files
                    <input
                        type="file"
                        id="assetImages"
                        name="assetImages"
                        accept="image/*"
                        multiple
                        onChange={handleChange}
                        className="upload-input"
                    />
                    </label>
                    {formData.assetImages && (
                      <p>
                        {Array.isArray(formData.assetImages)
                          ? formData.assetImages
                              .map((f) => (typeof f === "string" ? f.split("/").pop() : f.name))
                              .join(", ")
                          : typeof formData.assetImages === "string"
                          ? formData.assetImages.split("/").pop()
                          : ""}
                      </p>
                    )}
                </Box>
                </Grid>
              </Grid>

              <Divider sx={{ my: 4 }} />

              {/* Signature Section */}
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Signature
              </Typography>
              
              <FormControl component="fieldset" sx={{ mb: 3 }}>
                <FormLabel component="legend">Signature Type</FormLabel>
                <RadioGroup
                  row
                  value={signatureType}
                  onChange={(e) => setSignatureType(e.target.value)}
                >
                  <FormControlLabel
                    value="upload"
                    control={<Radio />}
                    label="Upload"
                  />
                  <FormControlLabel value="draw" control={<Radio />} label="Draw" />
                </RadioGroup>
              </FormControl>

              {signatureType === "upload" && (
                <Grid item xs={12}>
                <Box
                  className="upload-box"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ flexDirection: "column" }}
                >
                  <Typography
                    variant="subtitle1"
                    style={{ fontFamily: "Times New Roman" }}
                    gutterBottom
                  >
                    Upload Signature
                  </Typography>
                  <label htmlFor="signaturePath" className="upload-label">
                    Choose File
                    <input
                      type="file"
                      id="signaturePath"
                      name="signaturePath"
                      accept="image/*"
                      onChange={handleChange}
                      className="upload-input"
                    />
                  </label>
                    {formData.signaturePath && (
                      <p>
                        {Array.isArray(formData.signaturePath)
                          ? formData.signaturePath
                              .map((f) => (typeof f === "string" ? f.split("/").pop() : f.name))
                              .join(", ")
                          : typeof formData.signaturePath === "string"
                          ? formData.signaturePath.split("/").pop()
                          : ""}
                      </p>
                    )}
                </Box>
              </Grid>
              )}

              {signatureType === "draw" && (
                <Box sx={{ mb: 3 }}>
                  <SignaturePad
                    ref={signaturePadRef}
                    canvasProps={{ 
                      width: 500, 
                      height: 200,
                      style: { border: "1px solid #000", borderRadius: 8, maxWidth: '100%' }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => signaturePadRef.current?.clear()}
                    sx={{ mt: 1 }}
                  >
                    Clear Signature
                  </Button>
                </Box>
              )}

              
<Dialog
            open={openTerms}
            onClose={() => setOpenTerms(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle style={{ fontFamily: "Times New Roman" }}>
              Terms and Conditions
            </DialogTitle>
            <DialogContent dividers>
              <Typography
                variant="body2"
                style={{ fontFamily: "Times New Roman" }}
                gutterBottom
              >
                Please read the following terms carefully:
                <br />
                <br />
                1. This laptop/desktop is a company's asset and should be used
                for official purposes only.
                <br />
                2. Please maintain this asset in good condition.
                <br />
                3. Report any issue to IT team.
                <br />
                4. Employees may not take the System (Laptop / Desktop / Etc.)
                for repair to any external agency or vendor with/without IT
                approval.
                <br />
                5. Unauthorized software is not permitted.
                <br />
                6. Scan for viruses at least once every 15 days.
                <br />
                7. Company data must remain confidential.
                <br />
                8. Return the Asset during separation from the company.
                <br />
                9. Employee is liable for any misuse or damage.
                <br />
                10. In case of loss or theft, full cost recovery is applicable.
                <br />
                11. The organization reserves the right to deduct the same from
                salary or dues.
                <br />
              </Typography>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpenTerms(false)} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Box mt={4}>
            <Box display="flex" alignItems="center">
              <Checkbox
                checked={formData.termsAccepted}
                onChange={handleChange}
                name="termsAccepted"
              />
              <Typography
                variant="h6"
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "blue",
                }}
                onClick={() => setOpenTerms(true)}
                style={{ fontFamily: "Times New Roman" }}
              >
                I Agree The Terms and Conditions
              </Typography>
            </Box>
            <Typography
              variant="body2"
              style={{ fontFamily: "Times New Roman" }}
            >
              Location: Lat {latitude || "--"}, Long {longitude || "--"} | IP:{" "}
              {ipAddress || "--"}
            </Typography>
            </Box>

              {/* Action Buttons */}
              <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 4 }}>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  disabled={saving}
                  startIcon={<CancelIcon />}
                  size="large"
                >
                  Cancel
                </Button>
                
                <Button
                  type="submit"
                  variant="contained"
                  disabled={saving}
                  // onClick={sendEditPdf}
                  startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />}
                  size="large"
                >
                  {saving ? "Updating..." : "Update Record"}
                </Button>
              </Box>
            </form>
          </Paper>
        </Container>
      <ToastContainer position="top-center" autoClose={3000} />
    </AdminLayout>
  );
}

export default EditForm;